import React from 'react';

interface ILoadingProps {
  saving: boolean;
}

const LoadingStep: React.FC<ILoadingProps> = ({ saving }) => {
  return(
    <>
      <div className='bill-container-fit-screen-content'>
        <div className='loading-spinner-cont'>
          <svg className='spinner' xmlns='http://www.w3.org/2000/svg' width='32' height='33' viewBox='0 0 32 33' fill='none'>
            <g clipPath='url(#clip0_4006_13811)'>
              <circle cx='16' cy='3.75' r='3' fill='white' fillOpacity='0.1'/>
              <circle opacity='0.45' cx='16' cy='29.75' r='3' fill='white' fillOpacity='0.65'/>
              <circle cx='3' cy='16.75' r='3' fill='white' fillOpacity='0.85'/>
              <circle cx='29' cy='16.75' r='3' fill='white' fillOpacity='0.35'/>
              <circle cx='26' cy='7.75' r='3' fill='white' fillOpacity='0.25'/>
              <circle cx='26' cy='25.75' r='3' fill='white' fillOpacity='0.45'/>
              <circle cx='6' cy='25.75' r='3' fill='white' fillOpacity='0.75'/>
              <circle cx='6' cy='7.75' r='3' fill='white'/>
            </g>
            <defs>
              <clipPath id='clip0_4006_13811'>
                <rect width='32' height='32' fill='white' transform='translate(0 0.75)'/>
              </clipPath>
            </defs>
          </svg>
          <p>{saving ? 'Saving Ticket...' : 'Screening in Progress...'}</p>
        </div>
      </div>
    </>
  );
};
export default LoadingStep;
